import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../icon';
import Spinner from '../spinner';
import { deprecated } from '@loggi/ui/components/utils/warnings';
import {
  ACTIVE_COLOR,
  CIRCLE_SHAPE,
  COLORS,
  ICONS,
  LIGHT_STYLE,
  PRIMARY_STYLE,
  REGULAR_SIZE,
  ROUNDED_SHAPE,
  SHAPES,
  SIZES,
  SQUARE_SHAPE,
  STYLES,
  WHITE_COLOR
} from './types';

const { getButtonElement } = __NATIVE__
  ? require('./native')
  : require('./dom');
const MODE_BUTTON = 'button';
const MODE_SUBMIT = 'submit';
const MODE_RESET = 'reset';

class Button extends React.Component {
  static displayName = 'Button';

  static propTypes = {
    color: PropTypes.oneOf(COLORS),
    style: PropTypes.oneOf(STYLES),
    shape: PropTypes.oneOf(SHAPES),
    size: PropTypes.oneOf(SIZES),
    icon: PropTypes.oneOf(ICONS),
    block: PropTypes.bool,
    onSelect: PropTypes.func,
    onPress: PropTypes.func,
    href: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    isLoading: PropTypes.bool,
    isActivated: PropTypes.bool,
    disableFeedbackStyle: PropTypes.bool,
    mode: PropTypes.oneOf([MODE_SUBMIT, MODE_RESET, MODE_BUTTON]),

    //  Deprecated Props
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    circle: PropTypes.bool,
    iconOrientation: PropTypes.string,
    rounded: PropTypes.bool,
    type: PropTypes.string
  };

  static defaultProps = {
    block: false,
    circle: false,
    icon: null,
    type: null,
    rounded: false,
    value: null,
    href: null,
    shape: ROUNDED_SHAPE,
    color: ACTIVE_COLOR,
    style: PRIMARY_STYLE,
    size: REGULAR_SIZE,
    isLoading: false,
    isActivated: false,
    disabled: false,
    disableFeedbackStyle: false,
    mode: null
  };

  constructor(props) {
    super(props);

    this._onPress = this._onPress.bind(this);
    this._onRelease = this._onRelease.bind(this);

    this.state = {
      isPressing: false
    };

    if (__DEV__) {
      const boundDeprecated = deprecated.bind(this, 'Button');

      if (props.circle) {
        boundDeprecated('circle', 'shape="circle"');
      }
      if (props.rounded) {
        boundDeprecated('rounded', 'shape="rounded"');
      }
      if (props.type) {
        boundDeprecated('type', 'color and style props');
      }
      if (props.size === 'sm') {
        boundDeprecated('size="sm"', 'size="small"');
      }
      if (props.size === 'lg') {
        boundDeprecated('size="lg"', 'size="large"');
      }
      if (props.size === 'xs') {
        boundDeprecated('size="xs"', 'size="small"');
      }
      if (props.iconOrientation) {
        boundDeprecated('iconOrientation');
      }
      if (props.className) {
        /* eslint-disable */
        console.warn(
          '[ELKE] Component Button: the className prop are deprecated, buttons must be restritive about our' +
            ' design concepts, remove it or report this use case to loggi/ui repo'
        );
        /* eslint-enable */
        // its a custom message, not a single replace
      }
    }
  }

  _onPress() {
    const { onPress, disableFeedbackStyle } = this.props;
    this.setState(
      {
        isPressing: true && !disableFeedbackStyle
      },
      onPress
    );
  }

  _onRelease() {
    const { onRelease } = this.props;
    this.setState(
      {
        isPressing: false
      },
      onRelease
    );
  }

  render() {
    const {
      block,
      className,
      circle,
      icon,
      rounded,
      type,
      value,
      href,
      onSelect,
      onPress,
      disabled,
      shape,
      color,
      style,
      size,
      isLoading,
      mode,
      isActivated,
      disableFeedbackStyle,
      ...otherProps
    } = this.props;

    const { isPressing } = this.state;

    const buttonClasses = [
      'btn',
      { ['btn-disabled']: disabled },
      { [`btn-${color}-${style}`]: !isPressing && !isActivated },
      { [`btn-${color}-${style}-activated`]: isPressing || isActivated },
      { [`btn-${shape}`]: shape !== SQUARE_SHAPE && shape !== CIRCLE_SHAPE },
      { [`btn-${size}`]: size !== REGULAR_SIZE && !circle },
      { ['btn-block']: block },
      { ['btn-rounded']: rounded },
      { [`btn-circle-${size}`]: circle || shape === CIRCLE_SHAPE },
      { [`btn-${type}`]: type },
      className
    ];

    const spinnerColor =
      style === PRIMARY_STYLE || style === LIGHT_STYLE || disabled
        ? WHITE_COLOR
        : color;

    const content = isLoading
      ? [
          <Spinner
            key="loading"
            className={value ? 'btn-spinner' : null}
            color={spinnerColor}
          />,
          value
        ]
      : icon
      ? [
          <Icon key={icon} className={value ? 'btn-icon' : null} type={icon} />,
          value
        ]
      : [value];

    if (mode !== null) {
      otherProps.type = mode;
    }

    return getButtonElement(
      otherProps,
      content,
      disabled,
      buttonClasses,
      href || onSelect || onPress,
      this._onPress,
      this._onRelease,
      disableFeedbackStyle
    );
  }
}

export default Button;
